import { render, staticRenderFns } from "./AbaGeralOportunidade.vue?vue&type=template&id=18755edb"
import script from "./AbaGeralOportunidade.vue?vue&type=script&lang=js"
export * from "./AbaGeralOportunidade.vue?vue&type=script&lang=js"
import style0 from "./AbaGeralOportunidade.vue?vue&type=style&index=0&id=18755edb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports